if (!customElements.get('product-tile')) {  
  customElements.define(
    'product-tile',
    class ProductTile extends HTMLElement {
      constructor() {
        super();
        this.product_id = Number(this.dataset.productId);
      }

      checkProductWishlistStatus() {
        const wishlist_icon_container = this.querySelector('[data-wishlist-action]');
        const wishlist_icon = wishlist_icon_container.querySelector('svg');
        const wishlist_has_product_id = wishlist_items.find(item => item.empi === this.product_id);

        if (wishlist_has_product_id) {
          wishlist_icon.classList.remove('heart-icon-white');
          wishlist_icon.classList.add('heart-icon-soft-red');
        } else {
          wishlist_icon.classList.add('heart-icon-white');
          wishlist_icon.classList.remove('heart-icon-soft-red');
        }
      }

      swymInit() {
        this.checkProductWishlistStatus();

        document.addEventListener(`wishlist-items-updated`, () => {
          this.checkProductWishlistStatus();
        });


        this.addEventListener('click', e => {
          const clickedElement = e.target.closest('[data-wishlist-action]');
          if (!clickedElement) return;

          const wishlist_icon = clickedElement.querySelector('svg');
          const {
            wishlistProductId,
            wishlistVariantId,
          } = clickedElement.dataset;

          const variant_is_on_wishlist = wishlist_items.find(item => item.epi === Number(wishlistVariantId));
          const product = {
            epi: wishlistVariantId,
            empi: wishlistProductId,
            du: window.location.href,
          }

          const addSuccess = () => {
            wishlist_icon.classList.add('heart-icon-soft-red');
            wishlist_icon.classList.remove('heart-icon-white');

            swym_swat.fetchLists({
              callbackFn: getListSuccess,
              errorFn: swymOnError,
            });
          }

          const removeSuccess = () => {
            wishlist_icon.classList.remove('heart-icon-soft-red');
            wishlist_icon.classList.add('heart-icon-white');

            swym_swat.fetchLists({
              callbackFn: getListSuccess,
              errorFn: swymOnError,
            });
          }

          const swymError = (error) => {
            console.error("Error while adding the Product to the List", error);
            alert(`Error while adding the Product to the List: ${error}`);
          }

          if (variant_is_on_wishlist) {
            swym_swat.deleteFromList(default_list_id, product, removeSuccess, swymError);
          } else {
            swym_swat.addToList(default_list_id, product, addSuccess, swymError);
          }
        });
      }
    
      connectedCallback() {
        // poll(() => {
        //   return wishlist_items;
        // }, 10000, 150).then(() => {
        //   this.swymInit();
        // });
        
        const el = this.querySelector('[data-pr-component]:not([data-pr-mounted="true"])');
        if (!el.hasChildNodes() && el.dataset.prPageId) {
          window.pwr = window.pwr || function () {
            (pwr.q = pwr.q || []).push(arguments);
          };
          
          el.id = 'snippet-' + prRandomNumber();

          pwr("render", [{
            api_key: 'c8ca75c6-1918-488a-802c-49334cb0cc64',
            locale: 'en_US',
            merchant_group_id: '49431',
            merchant_id: '769366', 
            page_id: el.dataset.prPageId,
            ENABLE_CLIENT_SIDE_STRUCTURED_DATA: false,
            components: {
              CategorySnippet: el.id
            }
          }]);
          
          const observer = new MutationObserver(() => {
            if (el.querySelector('.pr-no-reviews')) {
              el.parentNode.removeChild(el);
              observer.disconnect();
            } else if (el.querySelector('.pr-category-snippet__total')) {
              setTimeout(() => {
                const widgetContent = el.cloneNode(true);
                el.parentNode.replaceChild(widgetContent, el);
                observer.disconnect();
              }, 50);
            }
          });
          
          observer.observe(el, { childList: true, subtree: true });
        }
      
        this.addEventListener('click', (e) => {
          const swatchToggle = e.target.closest('[data-swatch-toggle]');
          if (!swatchToggle) return;
                    
          const {
            id,
            url,
            featured_image,
            hover_image,
            title,
            price
          } = JSON.parse(swatchToggle.dataset.product);
          
          [...this.querySelectorAll('[data-show]')].forEach((el) => {
            if (Number(el.dataset.show) === Number(id)) {
              el.style.display = null;
              return;
            }
            el.style.display = 'none';
          });

          this.querySelectorAll('[data-swatch-toggle]').forEach(el => el.setAttribute('aria-current', el === swatchToggle));
          
          this.querySelectorAll('[data-product-url]').forEach((el) => { el.href = url });
          const featuredImageEl = this.querySelector('[data-featured_image]');
          if (featuredImageEl) {
            featuredImageEl.src = featured_image;
            featuredImageEl.srcset = '';
          }
          const hoverImageEl = this.querySelector('[data-hover_image]');
          if (hoverImageEl && hover_image) {
            hoverImageEl.src = hover_image;
            hoverImageEl.srcset = '';
            hoverImageEl.classList.remove('hidden');
          } else hoverImageEl.classList.add('hidden');
          
          this.querySelector('[data-product-title]').innerHTML = title.split(' - ')[0];
          this.querySelector('[data-product-price]').innerHTML = price.replaceAll('%27', "'").replaceAll('%22', '"');

          this.querySelectorAll('[data-swatch-toggle]').forEach((el) => {
            if (el.isSameNode(swatchToggle)) {
              el.classList.add('selected');
              return;
            }
            
            el.classList.remove('selected');
          });
        });
      }
    }
  );
}
